export default function acroynm(str) {
  const matches = str?.match(/\b(\w)/g);
  return matches ? matches?.slice(0, 3)?.join('') : '';
}
